// Copyright (c) 2015, MKraft Capability Solutions LLP
// License: GNU General Public License v3. See LICENSE

if (!window.palbon_core) window.palbon_core = {};

palbon_core.subscribe_to_newsletter = function (opts, btn) {
	return frappe.call({
		type: "POST",
		method: "frappe.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: { email: opts.email },
		callback: opts.callback,
	});
};
